import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsApi } from '../../../infrastructure/api/investigations.api';
import type { RouteInvestigationCommand } from './route-investigation.command';
import type { RouteInvestigationResult } from './route-investigation.result';

@Injectable({ providedIn: 'root' })
export class RouteInvestigationUseCase {
  private readonly _api = inject(InvestigationsApi);
  private readonly _toast = inject(ToastProvider);

  public execute(command: RouteInvestigationCommand): Observable<RouteInvestigationResult> {
    return this._api.routeInvestigation(command.investigationId).pipe(
      tap(() => {
        this._toast.success(
          'Investigation routed',
          'The investigation has been routed to the next assignee.',
        );
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._toast.error(
          'Failed to route investigation',
          'Please try again or contact support if the issue persists.',
        );
        return throwError(() => error);
      }),
    );
  }
}
